import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiAddress\UpdateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/UpdateWikiAddressController.php
* @route '/api/wiki-address/{wiki_address}'
*/
const UpdateWikiAddressController = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiAddressController.url(args, options),
    method: 'put',
})

UpdateWikiAddressController.definition = {
    methods: ["put"],
    url: '/api/wiki-address/{wiki_address}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiAddress\UpdateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/UpdateWikiAddressController.php
* @route '/api/wiki-address/{wiki_address}'
*/
UpdateWikiAddressController.url = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_address: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_address: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_address: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_address: typeof args.wiki_address === 'object'
        ? args.wiki_address.id
        : args.wiki_address,
    }

    return UpdateWikiAddressController.definition.url
            .replace('{wiki_address}', parsedArgs.wiki_address.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiAddress\UpdateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/UpdateWikiAddressController.php
* @route '/api/wiki-address/{wiki_address}'
*/
UpdateWikiAddressController.put = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiAddressController.url(args, options),
    method: 'put',
})

export default UpdateWikiAddressController